import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-between items-center py-2"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "flex flex-col items-end gap-3" }
const _hoisted_4 = { class: "text-xl font-bold" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(`bg-white ${
      _ctx.hasBorder ? 'border-b-4' : ''
    }  border-h-primary-500 rounded-lg shadow-sm h-full w-full p-3`)
  }, [
    (!_ctx.isEmpty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_ctx.img && _ctx.icon)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                name: _ctx.icon
              }, null, 8, ["name"]))
            : (_ctx.data.icon)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.data.icon,
                  alt: "card-image"
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.data.title), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.data.info), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "content")
        ]))
  ], 2))
}